import type { ColumnsType } from "antd/es/table";
import dayjs from 'dayjs';
import { CheckCircleFilled, QuestionCircleFilled, } from "@ant-design/icons";

import type { StoryTimeListType, StoryTimeGroupType } from "./storyTimeType"
import TableActions from "../components/TableActions"
import NormalTag from "../../../../components/tags/NormalTag";
import { NormalTagTypes } from "../../../../types/types";

export function createMainColumns(
  handleEdit: (record: StoryTimeListType) => void,
  handleDelete: (record: StoryTimeListType) => void,
): ColumnsType<StoryTimeListType> {
  return [
    {
      title: 'Story title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Content group',
      key: 'groupCount',
      render: (_, record) => record.groups?.length ?? 0,
    },
    {
      title: 'Completed',
      key: 'completed',
      render: (_, record) => {
        const isUndone = record.groups?.some(
          g => !g.isScriptDone || !g.isContentDone
        );
        return !isUndone ? (
          <span>
            Done
            <CheckCircleFilled className="done-icon" />
          </span >
        ) : (
          <span>
            Undone
            <QuestionCircleFilled className="undone-icon" />
          </span>
        );
      },
    },
    {
      title: 'Publish Date',
      dataIndex: 'publishDate',
      key: 'publishDate',
      render: (value) => value ? dayjs(value).format('YYYY-MM-DD') : "",
    },
    {
      title: 'Status',
      key: 'status',
      render: (_, record) => {
        const now = dayjs();
        const publishDate = dayjs(record.publishDate);
        if (now.isAfter(publishDate)) return <NormalTag type={NormalTagTypes.PUBLISHED} />;
        else return <NormalTag type={NormalTagTypes.PENDING} />;
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record) => (
        <TableActions
          onEdit={() => handleEdit(record)}
          onDelete={() => handleDelete(record)}
        />
      ),
    },
  ];
}

export function createSubColumns(
  handleEdit: (record: StoryTimeGroupType) => void,
): ColumnsType<StoryTimeGroupType> {
  return [
    {
      title: 'CAP',
      dataIndex: 'caps',
      key: 'caps',
      render: (caps: string[]) => caps.join(', '),
    },
    {
      title: 'Upload Media & Create Script',
      dataIndex: 'isScriptDone',
      key: 'isScriptDone',
      render: (value) => {
        return value ? (
          <span>
            Done
            <CheckCircleFilled className="done-icon" />
          </span >
        ) : (
          <span>
            Undone
            <QuestionCircleFilled className="undone-icon" />
          </span>
        );
      },
    },
    {
      title: 'Add Learning Content',
      dataIndex: 'isContentDone',
      key: 'isContentDone',
      render: (value) => {
        return value ? (
          <span>
            Done
            <CheckCircleFilled className="done-icon" />
          </span >
        ) : (
          <span>
            Undone
            <QuestionCircleFilled className="undone-icon" />
          </span>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record) => (
        <TableActions
          onEdit={() => handleEdit(record)}
          onDelete={() => null}
          showDelete={false}
        />
      ),
    },
  ];
}